import { permissionApi } from '../api';

export const permissionRepo = {
    getAll: (params) => permissionApi.getAll(params),
    getGrouped: () => permissionApi.getGrouped(),
    getModules: () => permissionApi.getModules(),
    getById: (id) => permissionApi.getById(id),
    getUsersWithPermissions: (params) => permissionApi.getUsersWithPermissions(params),
    getUserPermissions: (userlogId) => permissionApi.getUserPermissions(userlogId),
    getAvailable: () => permissionApi.getAvailable(),
    check: (data) => permissionApi.check(data),
    assign: (data) => permissionApi.assign(data),
    revoke: (data) => permissionApi.revoke(data),
    sync: (userlogId, permissionIds) => permissionApi.sync(userlogId, permissionIds),
};